export default "__VITE_ASSET__CsO2021w__"